import DM from 'DM';

const IAB_TRACKERS = ['rtb', 'qgraph'];

class ExternalTrackers {
    constructor() {
        this.trackers = {};
    }

    register(tracker) {
        this.trackers[tracker.name] = tracker;
    }

    dispatch(tracker, event, payload) {
        const trackerType = tracker === 'wppixel' ? 'GWP' : 'TP';

        if (!DM.Utils.getCookie(DM.Cookies.KillTrackers) && !DM.Utils.killTracker(tracker)) {
            if (window.WP.gdpr.check('mr', trackerType) || IAB_TRACKERS.includes(tracker)) {
                if ('requestIdleCallback' in window) {
                    window.requestIdleCallback(() => {
                        this.trackers[tracker].dispatch(event, payload);
                    })
                } else {
                    this.trackers[tracker].dispatch(event, payload);
                }
            }
        }
    }

    track(event, payload) {
        window.WP.push(() => {
            window.WP.gdpr.runAfterConsent(() => {
                Object.keys(this.trackers).forEach(tracker => {
                    this.dispatch(tracker, event, payload);
                });
            });
        });
    }
}

export default ExternalTrackers;
